import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Chip,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Progress,
  Timeline,
  TimelineConnector,
  TimelineHeader,
  TimelineIcon,
  TimelineItem,
  Typography
} from "@material-tailwind/react";
import Dict from "../../helper/dict";
import React, {useContext, useEffect, useState} from "react";
import "../../style/datePicker.css"
import persianNumberFormat from "../../helper/PersianNumberFormat";
import {getServiceActivities} from "../../services/service/service_activity";
import {ServiceContext} from "../../context/service";
import FileCell from "../system/fileViewer";
import {BsCheckSquare, BsHourglassSplit} from "react-icons/bs";
import gregorianToJalali from "../../helper/jalaaliDateTime";

export function ServiceActivities() {

  const [serviceSteps, setServiceSteps] = useState([])
  const [progressPercentage, setProgressPercentage] = useState(0)

  const {
    service,
    modalOpen,
    setModalOpen,
    lastDataRefresh,
    setLastDataRefresh,
    from,
    setStep
  } = useContext(ServiceContext);

  const disable = service.status === "finish"

  const handleOpen = () => setModalOpen(!modalOpen);

  const [serviceActivities, setServiceActivities] = useState({});


  useEffect(() => {
    async function getData() {
      const result = await getServiceActivities(service.id);
      if (result.status === 200) {
        const {serviceActivitiesList, serviceStepsList} = result.data;
        setServiceActivities(serviceActivitiesList || []);
        setServiceSteps(serviceStepsList || []);
        setProgressPercentage(serviceStepsList && serviceStepsList.length > 0 ? (serviceStepsList.filter(step => step.is_done).length / serviceStepsList.length) * 100 : 0);

      }
    }

    if (service.id) {
      getData()
    }
  }, [service, lastDataRefresh]);

  if (serviceActivities.length > 0 && serviceSteps.length > 0) {
    return (
      <Dialog size="xl" open={modalOpen} handler={handleOpen}
              animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}
              className="max-h-screen overflow-y-scroll mt-20 mb-20">
        <DialogHeader className="border-b">
          {from === "person" &&
            <Typography>
              {"گزارش پیشرفت خدمات" + " - " + service.agent_name + " " + service.agent_family + " - " + service.field_title + " " + service.branch_title}
            </Typography>
          }
          {from === "agent" &&
            <Typography>
              {"گزارش پیشرفت خدمات" + " - " + service.person_name + " " + service.person_family + " - " + service.field_title + " " + service.branch_title}
            </Typography>
          }
        </DialogHeader>
        <DialogBody className="flex flex-col gap-4 overflow-y-scroll">
          {from === "agent" && !disable &&
            <div className="flex flex-row justify-end mb-4">
              <Button className="" onClick={() => {
                setStep("action");
              }} variant="outlined">ثبت عملیات جدید</Button>
            </div>}
          <div>
            <Typography color="blue-gray" variant="h5" className="textRight mb-4">
              مراحل انجام خدمت:
            </Typography>
            {progressPercentage > 0 &&
              <Progress value={Math.ceil(progressPercentage)} size="lg" label="پیشرفت"
                        className="text-right"/>
            }
            <Timeline className="mt-4">
              {serviceSteps.length > 0 && serviceSteps.map(
                ({
                   id,
                   title,
                   description,
                   is_done,
                   days,
                   dead_line,
                   updated_at,
                 }, index) => {
                  const isLast = index === serviceSteps.length - 1;
                  const classes = "relative rounded-xl border bg-white border-blue-gray-50 py-3 pl-4 pr-8 shadow-lg shadow-blue-gray-900/5" + (is_done ? " mx-2 scale-[1.03]" : " mx-4");

                  return (
                    <TimelineItem className="h-28 text-right textRight">
                      {!isLast &&
                        <TimelineConnector className="right-8 text-green-300" color={"green"}/>
                      }
                      <TimelineHeader
                        className={`${classes} ${Date.now() > Date.parse(dead_line) ? "bg-red-200" : ""} ${is_done ? "bg-green-100" : ""}`}>
                        <TimelineIcon className="p-3" variant="filled" color={is_done ? "green" : "amber"}>
                          {is_done ? <BsCheckSquare className="h-5 w-5"/> : <BsHourglassSplit className="h-5 w-5"/>}
                        </TimelineIcon>
                        <div className="flex flex-col gap-1">
                          <Typography variant="h6" color="blue-gray">
                            {title}
                          </Typography>
                          <Typography variant="small" color="gray" className="font-normal">
                            {is_done ?
                              `زمان انجام: ${persianNumberFormat(updated_at.split(" ")[1])} ${persianNumberFormat(updated_at.split(" ")[0])}`
                              :
                              `مهلت انجام: ${persianNumberFormat(gregorianToJalali(dead_line))}`
                            }

                          </Typography>
                        </div>
                      </TimelineHeader>
                    </TimelineItem>
                  )
                }
              )
              }
            </Timeline>
          </div>
          <Typography color="blue-gray" variant="h5" className="textRight my-4">
            فعالیت‌های انجام خدمت:
          </Typography>
          <>
            {serviceActivities.map(
              ({type, meta_text, description, file, created_at}, index) => {
                return (
                  <Card color="transparent" shadow={false} className="p-2 w-full   border-2 mb-2">
                    <CardHeader
                      color="transparent"
                      floated={false}
                      shadow={false}
                      className="mx-0 flex items-center gap-4 pt-0 pb-8"
                    >
                      <div className="flex w-full flex-row justify-between gap-2">
                        <div className="flex items-center justify-between">
                          <Chip
                            variant="ghost"
                            color={type === "file_accepted" ? "teal" :
                              type === "file_rejected" ? "red" :
                                type === "file_new" ? "cyan" :
                                  type === "file_upload" ? "purple" :
                                    type === "price" || type === "payment" || type === "day" ? "blue" :
                                      type === "start" || type === "ready_for_payment" ? "amber" :
                                        type === "action" ? "indigo" :
                                          "red"}
                            size="sm"
                            value={Dict(`${type}`)}
                          />
                        </div>
                        <Typography>{persianNumberFormat(created_at)}</Typography>
                      </div>
                    </CardHeader>
                    <CardBody className="-mt-4 mb-2 p-0">
                      <Typography color="blue-gray">
                        {!meta_text && Dict("type_" + type)}
                        {meta_text && type !== "price" && type !== "payment" && type !== "day" && Dict("type_" + type).replace("*", meta_text)}
                        {(meta_text && type === "price" || type === "payment" || type === "day") && Dict("type_" + type).replace("*", persianNumberFormat(meta_text, true))}

                        {description?.length > 0 &&
                          <Typography className="font-light" color="blue-gray">
                            {`توضیحات: ${description}`}
                          </Typography>
                        }
                      </Typography>
                      {file &&
                        <div className="mb-4">
                          <FileCell
                            label={Dict('file')}
                            fileCode={file}
                          />
                        </div>
                      }
                    </CardBody>
                  </Card>
                )
              }
            )}
          </>
        </DialogBody>
        <DialogFooter className="space-x-2">
          <Button variant="text" color="gray" onClick={() => {
            handleOpen()
          }}>
            <span>بستن</span>
          </Button>
        </DialogFooter>
      </Dialog>
    )
  }
}